{
  "heading": "My account",
  "logout": "Sign out",
  "unverifiedBanner": "Your email address is not confirmed yet. Some actions will stay unavailable.",
  "readOnlyNotice": "Confirm your email address to edit your account.",
  "saved": "Changes saved.",
  "save": "Save",
  "saving": "Saving…",
  "identity": {
    "heading": "Identity",
    "email": "Email address",
    "emailHint": "Changing your address will come with verification of the new recipient.",
    "firstName": "First name",
    "lastName": "Last name",
    "displayName": "Display name",
    "displayNameHint": "Leave empty to show “first name last name”.",
    "locale": "Language",
    "timezone": "Time zone",
    "roles": "Roles",
    "permissionCount": "Permissions"
  },
  "profile": {
    "heading": "Profile",
    "intro": "This information is visible to other users of the platform.",
    "headline": "Headline",
    "headlinePlaceholder": "Mathematics teacher",
    "bio": "About you",
    "bioHint": "{{count}} characters maximum.",
    "subjects": "Subjects",
    "subjectsHint": "Separate with commas.",
    "languages": "Teaching languages",
    "website": "Website",
    "websiteHint": "Full address, starting with https://",
    "verified": "Verified profile"
  },
  "preferences": {
    "heading": "Preferences",
    "shareProgress": "Share my progress with my teachers",
    "shareProgressHint": "Outside the courses you are enrolled in. You can change your mind at any time.",
    "marketingEmails": "Receive platform news",
    "marketingEmailsHint": "Emails about your account and your courses are sent in any case.",
    "consentNotice": "Your sharing choices are dated and kept, so you can tell since when they apply.",
    "theme": "Theme",
    "themes": {
      "system": "Match my system",
      "light": "Light",
      "dark": "Dark"
    }
  },
  "privacy": {
    "heading": "My data",
    "export": {
      "heading": "Export my data",
      "description": "Download everything held about you: account, profile, preferences, roles, active sessions and the dated history of your consents. The file is in JSON format.",
      "action": "Download my data",
      "pending": "Preparing…",
      "done": "The download has started."
    },
    "deletion": {
      "heading": "Delete my account",
      "description": "Your account will be anonymised 30 days after your request. Identifying data will be erased; what you published stays, without pointing to you any more. You can change your mind until that date.",
      "start": "Delete my account",
      "confirmLabel": "Type {{email}} to confirm.",
      "confirm": "Confirm deletion",
      "abort": "Cancel",
      "scheduled": "Your account will be deleted on {{date}}.",
      "stillUsable": "Until then, your account works normally and you can change your mind.",
      "cancel": "Keep my account"
    }
  },
  "sessions": {
    "heading": "Active sessions",
    "revoke": "Close",
    "current": "(current session)",
    "unknownDevice": "Unknown device",
    "lastUsed": "Last used on {{date}}",
    "loading": "Loading sessions…"
  },
  "loading": "Loading your account…",
  "languages": {
    "fr": "French",
    "en": "English"
  }
}
